// src/api/userCache.js
import { fetchMeInfo, fetchMemberships } from "@/api/auth"
import { getMyProfile } from "@/api/kuizy"

const ME_KEY = "meInfoCache"
const PROFILE_KEY = orgId => `myProfileCache:${orgId || ""}`
const MEMBERSHIPS_KEY = "membershipsCache";

const readJSON = k => { try { const s = localStorage.getItem(k); return s ? JSON.parse(s) : null } catch { return null } }
const writeJSON = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v ?? {})) } catch { } }

let meMem = null
let meInflight = null
const profileMem = new Map()
const profileInflight = new Map()
let membershipsMem = null;
let membershipsInflight = null;

export const getMeCached = async () => {
  if (meMem) return meMem
  const cached = readJSON(ME_KEY)
  if (cached) { meMem = cached; return cached }
  if (meInflight) return meInflight
  meInflight = fetchMeInfo().then(r => {
    const me = r.data || {}
    if (me?.user_id) localStorage.setItem("userId", me.user_id)
    writeJSON(ME_KEY, me)
    meMem = me
    meInflight = null
    return me
  }).catch(e => { meInflight = null; throw e })

  return meInflight
}

export const getMyProfileCached = async () => {
  const orgId = localStorage.getItem("orgId") || ""
  const k = PROFILE_KEY(orgId)
  if (profileMem.has(k)) return profileMem.get(k)
  const cached = readJSON(k)
  if (cached) { profileMem.set(k, cached); return cached }
  if (profileInflight.has(k)) return profileInflight.get(k)
  const p = getMyProfile().then(r => {
    const data = r.data || {}
    writeJSON(k, data)
    profileMem.set(k, data)
    profileInflight.delete(k)
    return data
  }).catch(e => { profileInflight.delete(k); throw e })
  profileInflight.set(k, p)
  return p
}


export const getMembershipsCached = async (force = false) => {
  if (!force && membershipsMem) return membershipsMem;

  if (!force) {
    const cached = readJSON(MEMBERSHIPS_KEY);
    if (cached) { membershipsMem = cached; return cached; }
    if (membershipsInflight) return membershipsInflight;
  }

  membershipsInflight = import("@/api/auth").then(({ fetchMemberships }) => fetchMemberships())
    .then(r => {
      const data = r.data || {};
      membershipsMem = data;
      writeJSON(MEMBERSHIPS_KEY, data);

      // sync orgId ใน localStorage ถ้ายังไม่มี หรือ active_org_id เปลี่ยน
      const currentOrgId = localStorage.getItem("orgId");
      if (data?.active_org_id && data.active_org_id !== currentOrgId) {
        localStorage.setItem("orgId", data.active_org_id);
      }

      membershipsInflight = null;
      return data;
    })
    .catch(e => { membershipsInflight = null; throw e });

  return membershipsInflight;
};


export const setMyProfileCache = (p) => {
  const orgId = localStorage.getItem("orgId") || ""
  const k = PROFILE_KEY(orgId)
  writeJSON(k, p || {})
  profileMem.set(k, p || {})
}

export const clearUserCache = () => {
  meMem = null
  meInflight = null
  profileMem.clear()
  profileInflight.clear()
  const toRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (!key) continue
    if (key === ME_KEY) toRemove.push(key)
    if (key.startsWith("myProfileCache:")) toRemove.push(key)
    if (key === "meCache" || key === "meInfoCache") toRemove.push(key)
    if (key === "membershipsCache") toRemove.push(key)
  }
  toRemove.forEach(k => localStorage.removeItem(k))
}
